/**
 * AdditionalDetailsSection - Existing details (read-only) + new additional details textarea
 */

const AdditionalDetailsSection = ({ formState, dispatch, existingDetails, disabled }) => (
  <div>
    <h4 className="font-medium text-gray-900 dark:text-white mb-3">Additional Details</h4>
    <div className="space-y-3">
      {/* Show existing details in read-only block when editing */}
      {existingDetails && (
        <div>
          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
            Previous Details
          </label>
          <div className="p-3 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-600 dark:text-gray-400 italic whitespace-pre-wrap">
            {existingDetails}
          </div>
        </div>
      )}

      <div>
        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
          Additional Details (Optional)
        </label>
        <textarea
          value={formState.additionalDetails}
          onChange={(e) => dispatch({ type: 'SET_FIELD', field: 'additionalDetails', value: e.target.value })}
          placeholder="Enter any other details the compliance team should know"
          disabled={disabled}
          rows={3}
          className="w-full px-4 py-3.5 border border-gray-300 dark:border-gray-600 rounded-xl text-base sm:text-sm bg-white dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-primary/20 focus:border-primary disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed transition-all duration-200 placeholder:text-gray-400 dark:placeholder:text-gray-500 resize-none"
        />
      </div>
    </div>
  </div>
);

export default AdditionalDetailsSection;
